import React from 'react';

import { Box, Icon, Text } from '@betterment/samba-react';
import { Button, CenteredWorkflowLayout, Heading } from '@betterment/style-closet-react';

import Footer from '../../Shared/components/Footer';
import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';

const InactiveCheckingUser: React.FC<React.PropsWithChildren<unknown>> = () => {
  const goToAppSummary = () => {
    locationAssign(urlBuilder.appHome.absolute());
  };

  return (
    <CenteredWorkflowLayout title="Checking">
      <CenteredWorkflowLayout.Slot name="content">
        <Box
          css={{
            marginBlock: 'space.300',
          }}
        >
          <Icon name="ExclamationCircle" size="large" color="icon" />
        </Box>
        <Heading variant="primary" mb="8">
          We're unable to access Checking for you at this time
        </Heading>
        <Box
          css={{
            marginBottom: 'space.800',
          }}
        >
          <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
            You are unable to view this page because you don't have an active Checking account.
          </Text>
        </Box>
        <Button px="8" mb="11" onClick={goToAppSummary}>
          Got it
        </Button>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};
export default InactiveCheckingUser;
